import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function DeleteConfirmation({
  open,
  handleClose,
  handleSubmit,
  title,
}) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            textAlign: "center",
          }}
        >
          {title ??
            "Are you sure you want to delete this recommendation product ?"}
        </DialogTitle>
        <DialogContent
          style={{
            padding: 10,
          }}
        >
          {/* <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this recommendation product ?{" "}
          </DialogContentText> */}
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            paddingBottom: 20,
          }}
        >
          <Button
            onClick={(e) => {
              e.stopPropagation();
              handleClose();
            }}
            // color="primary"
            variant="contained"
            style={{
              width: "30%",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              handleSubmit();
            }}
            autoFocus
            color="secondary"
            variant="contained"
            style={{
              width: "30%",
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
